export default {
  getAppList: {
    method: 'get',
    url: 'app/store/list'
  },
  getAppOption: {
    method: 'get',
    url: 'app/store/option'
  },
  getDeviceAppList: {
    method: 'get',
    url: 'device/app/list'
  }
}
